import SafeInnerHtml from './safeInnerHtml'

export default SafeInnerHtml



// WEBPACK FOOTER //
// ./client/components/safeInnerHtml/index.tsx